<template>
    <AuthPageInner title="Forgot Password">
       <ForgotPasswordForm ref="form" @success="onSuccess"/>
    </AuthPageInner>
</template>

<script>

import axios from "axios";
import AuthPageInner from "@/Components/Layout/AuthPageInner";
import ForgotPasswordForm from "@/Components/Auth/ForgotPasswordForm";

export default {

    name: "ForgotPasswordPage",

    components: {
        AuthPageInner,
        ForgotPasswordForm
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.form.focus();
        });
    },

    methods: {
        onSuccess() {
           //
        }
    },

    async beforeRouteEnter(to, from, next) {
        await axios.head(route('password.request'));
        next();
    },
}
</script>
